import { render, staticRenderFns } from "./ChooseStartEnd.vue?vue&type=template&id=23fd0dba&scoped=true&"
import script from "./ChooseStartEnd.vue?vue&type=script&lang=js&"
export * from "./ChooseStartEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd0dba",
  null
  
)

export default component.exports